import React, { useState, useEffect, useRef, useContext } from 'react';
import axios from 'axios';
import { Link, useParams } from 'react-router-dom';
import LoadingScreen from '../loading/LoadingScreen';
import { confirmEmailChange } from '../../utils/getData/User';
import AuthContext from '../../utils/auth/AuthContext';

// メール内のURLから遷移してくる画面
// 変更が成立するとJWTの識別子(メールアドレス)が変わり既存のトークンが無効になるため、
// ログイン状態にかかわらずトークンのみで処理し、完了後は再ログインを案内する
const EmailChangeConfirm: React.FC = () => {
  const { token = "" } = useParams();
  const [status, setStatus] = useState("loading");
  const [message, setMessage] = useState("");
  const { setAuthentication } = useContext(AuthContext);
  // StrictModeの二重実行で「使用済み」エラーにならないようにする
  const requested = useRef(false);

  useEffect(() => {
    const confirm = async () => {
      if (requested.current) {
        return;
      }
      requested.current = true;

      if (token === "") {
        setMessage("URLが正しくありません。お手数ですがマイページから再度お手続きください。");
        setStatus("error");
        return;
      }

      try {
        // クッキーは httponly なので JS からは消せない。確定APIのレスポンスが削除する。
        await confirmEmailChange(token);
        // このタブがログイン状態のままだと /login がトップへリダイレクトされてしまう
        setAuthentication(false);
        setStatus("complete");
      } catch (error) {
        if (axios.isAxiosError(error) && error.response && error.response.status === 400) {
          const data = error.response.data as { detail?: string };
          setMessage(data && data.detail ? data.detail : "メールアドレスの変更に失敗しました。お手数ですがマイページから再度お手続きください。");
        } else {
          setMessage("メールアドレスの変更に失敗しました。時間を空けてもう一度お試しください。");
        }
        setStatus("error");
      }
    }
    confirm();
  }, [token, setAuthentication]);

  if (status === "loading") {
    return <LoadingScreen />;
  }

  if (status === "error") {
    return (
      <>
        <p className="topTitle">メールアドレス変更</p>
        <div className="px-1 mainSection">
          <p className="fs-description text-danger my-3">{message}</p>
          <Link className="btn btn-primary min-w-200 mx-auto mt-3 mb-2 px-2 py-1" to="/">トップへ戻る</Link>
        </div>
      </>
    );
  }

  return (
    <>
      <p className="topTitle">メールアドレス変更完了</p>
      <div className="px-1 mainSection">
        <p className="fs-description mb-3">
          メールアドレスの変更が完了しました。
        </p>
        <p className="fs-description mb-3">
          セキュリティのため、変更に伴い一度ログアウトしています。<br />
          お手数ですが「ログインする」ボタンから、新しいメールアドレスで再度ログインしてください。
        </p>
        <p className="fs-caption mb-3">
          ※パスワードはこれまでと同じものをご利用いただけます。
        </p>
        <Link className="btn btn-primary min-w-200 mx-auto mt-3 mb-2 px-2 py-1" to="/login">ログインする</Link>
      </div>
    </>
  );
};

export default EmailChangeConfirm;
